const COOKIE_ACTIVE_BLOG_ID = "activeBlogId"
const SUBSCRIBE_MODAL_SHOWN = "subscribeModalShown-"

const UTM_KEY = "utm-"

import Cookies from "js-cookie"

export const removeActiveBlogId = (): void =>
  Cookies.remove(COOKIE_ACTIVE_BLOG_ID)

/**
 * We only want the subscribe modal to be auto-shown once per blog.
 * The first time we display it, we set a cookie to remember that it has been shown
 * so we don't show it again.
 */
export const setSubscribeModalShown = (blogId: string): string | undefined =>
  Cookies.set(SUBSCRIBE_MODAL_SHOWN + blogId, "true", {
    expires: 30,
  })

/**
 * Fetches and returns the serialized UTM cookie string for a given blog.
 * @param blogId
 * @returns Serialized UTM cookie string.
 */
export const getUtmCookie = (blogId: string): string | undefined =>
  Cookies.get(`${UTM_KEY}${blogId}`) as string | undefined

const cookiesToClear = [
  "jwt",
  "activeTeamId",
  "activeBlogId",
  "userId",
  "privy-token",
  "privy-id-token",
]

export const removeJwtCookies = (): void => {
  // Remove all relevant cookies.
  cookiesToClear.forEach((cookie) => {
    Cookies.remove(cookie)
    Cookies.remove(cookie, {
      path: "/",
      domain: ".paragraph.com",
      secure: true,
      samesite: "none",
    })
  })
}
